import { makeStyles } from "tss-react/mui"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { useFormikContext } from "formik"
import { CreateRoomResourceForm } from "../../resourcesTypes"
import { SyntheticEvent, useEffect } from "react"
import { fieldTabMap, TabsOrder } from "./formConstants"
import { enqueueSnackbar } from "notistack"
import { TranslationKey } from "../../../../../../localization/translations"
import { Box, Tab, Tabs } from "@mui/material"
import { useMatchEnvironment } from "../../../../../../environment/envHooks"
import { EnvironmentType } from "../../../../../../environment/envTypes"

const TABLE_ARRANGEMENTS_ENVIRONMENTS = [EnvironmentType.Local, EnvironmentType.Test]

const useStyles = makeStyles()(() => ({
    tabs: {
        borderBottom: 1,
        borderColor: "divider",
    },
    tab: {
        textTransform: "none",
    },
    error: {
        // color: theme.palette.tailwind.red[500], // make tab red
    },
}))

export function RoomFormTabs(props: { value: number; onChange: (event: SyntheticEvent, newValue: number) => void }) {
    const { value, onChange } = props
    const { l10n } = useAppLocalization()
    const { errors, isSubmitting } = useFormikContext<CreateRoomResourceForm>()
    const showTableArrangements = useMatchEnvironment(TABLE_ARRANGEMENTS_ENVIRONMENTS)

    const { classes, cx } = useStyles()

    const hasErrors = (tabIndex: number): boolean => {
        return Object.keys(errors).some((field) => fieldTabMap[field as keyof CreateRoomResourceForm] === tabIndex)
    }

    useEffect(() => {
        let errorMessageKey = undefined

        if (hasErrors(TabsOrder.GENERAL)) {
            errorMessageKey = "resources-create-edit-room-general-tab-error"
        }
        if (hasErrors(TabsOrder.TABLE_ARRANGEMENTS)) {
            errorMessageKey = "resources-create-edit-room-general-tab-error"
        }
        if (hasErrors(TabsOrder.AVAILABILITY)) {
            errorMessageKey = "resources-create-edit-room-general-tab-error"
        }
        if (hasErrors(TabsOrder.ACCESS_CONTROL)) {
            errorMessageKey = "resources-create-edit-room-general-tab-error"
        }

        if (!errorMessageKey || !isSubmitting) return

        enqueueSnackbar({
            variant: "error",
            message: l10n.getString(errorMessageKey as TranslationKey),
        })
    }, [errors, isSubmitting])

    return (
        <Box className={classes.tabs}>
            <Tabs value={value} onChange={onChange}>
                <Tab
                    value={TabsOrder.GENERAL}
                    label={l10n.getString("resources-create-edit-room-general-tab-general")}
                    className={cx(classes.tab, hasErrors(TabsOrder.GENERAL) && classes.error)}
                    wrapped
                />
                {showTableArrangements && (
                    <Tab
                        value={TabsOrder.TABLE_ARRANGEMENTS}
                        label={l10n.getString("resources-create-edit-room-general-tab-table-arrangements")}
                        className={cx(classes.tab, hasErrors(TabsOrder.TABLE_ARRANGEMENTS) && classes.error)}
                        wrapped
                    />
                )}
                <Tab
                    value={TabsOrder.AVAILABILITY}
                    label={l10n.getString("resources-create-edit-room-general-tab-availability")}
                    className={cx(classes.tab, hasErrors(TabsOrder.AVAILABILITY) && classes.error)}
                    wrapped
                />
                <Tab
                    value={TabsOrder.ACCESS_CONTROL}
                    label={l10n.getString("resources-create-edit-room-general-tab-access-control")}
                    className={cx(classes.tab, hasErrors(TabsOrder.ACCESS_CONTROL) && classes.error)}
                    wrapped
                />
            </Tabs>
        </Box>
    )
}

